import { render, staticRenderFns } from "./ActivateDeactivateIssuerTypeDialog.vue?vue&type=template&id=71d22494"
import script from "./ActivateDeactivateIssuerTypeDialog.vue?vue&type=script&lang=js"
export * from "./ActivateDeactivateIssuerTypeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports